export const DEFAULT_SALE_VOUCHER_A5_COMPANIES = [
  '20542356155', // Ferretería Rivera
];
